import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonService } from '../Services/common.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PlatformChargesClient, PlatformChargesGetDTO, PurchaseHistoryRevenueDTO, RoomOwnerPlatformCharge, RoomWiseRevenueDTO, User, WebinarClient, WebinarRoomDTO, WebinarRoomOwnerDTO } from '../Services/WOWApi.Service';
import { CommonServices } from '../Common/CommonServices';
import moment from 'moment';
import { EditPlatformChargeComponent } from './edit-platform-charge/edit-platform-charge.component';
import { ExcelService } from '../Services/excel.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CustomServiceService } from '../Services/custom-service.service';

@Component({
    selector: 'app-owners-portal',
    templateUrl: './owners-portal.component.html',
    styleUrls: ['./owners-portal.component.css'],
    standalone: false
})
export class OwnersPortalComponent implements OnInit {
  request:boolean = true;
  fflImages:boolean = false;
  webinarQueue:boolean = false;
  luckyBucks:boolean = false;
  selectedTab:number = 0;
  isMobileView = false;
  subscription: Subscription;
  RevenueForm: UntypedFormGroup;
  minDate: Date;
  roomsList: WebinarRoomDTO[] = [];
  ownerRoomsList: WebinarRoomOwnerDTO[] = [];
  isLoading: any = {};
  roomWiseRevenue: RoomWiseRevenueDTO;
  allPlatformCharges: PlatformChargesGetDTO[] | any = [];
  isShowSettlement = false;
  isShowCompletedSettlement = false;
  selectedOptionToViewForMobile: string = '';
  userDetails: User;
  constructor(
    private commonService: CommonService,
    private fb: UntypedFormBuilder,
    private webinarClient: WebinarClient,
    private commonServices: CommonServices,
    private platformChargesClient: PlatformChargesClient,
    private dialog: MatDialog,
    private excelService: ExcelService,
    private customServices: CustomServiceService
    ) {
      this.commonService.setSpinner(true);
    }

  ngOnInit(): void {
    console.log("ddfsdf_1");
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.userDetails = this.customServices.GetLoggedInUser();
    this.buildRevenueForm();
    this.getAllPlatformCharges();
    // Load all rooms for owner portal (no user restriction)
    this.getOwnerWebinarRoomsList();
  }

  buildRevenueForm() {
    this.RevenueForm = this.fb.group({
      StartDate: ['', [Validators.required]],
      EndDate: ['', [Validators.required]],
      RoomId: ['', [Validators.required]]
    });
    this.RevenueForm.controls.StartDate.valueChanges.subscribe(value => {
      this.minDate = value;
    });
    const now = new Date();
    const month = moment(now).month();
    const endDate = moment(now).endOf('month').toDate();
    const startDate = moment(now).startOf('month').toDate();
    this.RevenueForm.controls.StartDate.patchValue(startDate);
    this.RevenueForm.controls.EndDate.patchValue(endDate);
    this.getWebinarRoomsList();
  }

  tabChange(index: number){
    this.request  = false;
    this.luckyBucks = false;
    this.fflImages  = false;
    this.webinarQueue  = false;
     
    switch(index)
    {
      case 0 :
        this.request = true;
        break;
      // case 1 :
      //   this.fflImages = true;
      //   break;
      case 1 :
        this.webinarQueue = true;
        break;
      case 3 :
        this.luckyBucks = true;
        break;
      
    }  
  }

  getWebinarRoomsList() {
    this.isLoading.rooms = true;
    this.webinarClient.getAllMAppedRoomsList().subscribe(res => {
      this.roomsList = res;
      let allRooms = new WebinarRoomDTO();
      allRooms.roomId = 0;
      allRooms.roomName = 'All Rooms';
      this.roomsList.unshift(allRooms); 
      this.isLoading.rooms = false;
      this.RevenueForm.controls.RoomId.patchValue(this.roomsList[0].roomId.toString());
    }, error => {
      console.error(error);
      this.isLoading.rooms = false;
    });
  }

  getRoomWiseRevenueBetweenDates() {
    // 2009-06-15T13:45:30
    if (!this.RevenueForm.valid) {
      this.commonServices.showMessage('error', `Please provide start date, end date and select room to proceed`);
      return;
    }
    this.isLoading.revenue = true;
    const roomId = this.RevenueForm.controls.RoomId.value;
    const dateFrom = moment(this.RevenueForm.controls.StartDate.value).format('yyy-MM-DD') + 'T00:00:00';
    const dateTo = moment(this.RevenueForm.controls.EndDate.value).format('yyy-MM-DD') + 'T00:00:00';
    this.webinarClient.getRoomWiseRevenue(roomId, new Date(dateFrom), new Date(dateTo)).subscribe(res => {
      if (res !== null) {
        this.roomWiseRevenue = res;
      } else {
        this.roomWiseRevenue = null;
      }
      this.isLoading.revenue = false;
    }, error => {
      this.isLoading.revenue = false;
    });
  }

  getAllPlatformCharges() {
    this.platformChargesClient.getAll().subscribe(res => {
      this.allPlatformCharges = res;
      console.log(res)
      this.allPlatformCharges.map(x => {
        if (x.platformCharge.percentage !== undefined && x.platformCharge.percentage !== null) {
          x.platformCharge.percentage = x.platformCharge.percentage.toFixed(2)
        }
      });
      console.log(this.allPlatformCharges);
    }, error => {
      console.log(error);
    });
  }

  onUpdatePlatformCharge(charge: PlatformChargesGetDTO) {
    this.dialog.open(EditPlatformChargeComponent, {
      width: '440px',
      maxWidth: '95vw',
      autoFocus: 'dialog',
      panelClass: 'platform-charge-dialog-panel',
      data: charge
    }).afterClosed().subscribe(res => {
      if (res !== undefined && res.action === 'success') {
        const charges = JSON.parse(JSON.stringify(this.allPlatformCharges));
        const idx = charges.findIndex(x => x.webinarRoom.roomId === res.obj.platformCharge.webinarRoomOwner.webinarRoomId);
        charges[idx] = res.obj;
        this.allPlatformCharges = [];
        this.allPlatformCharges = charges;
      }
    });
  }

  onTabChange(tab: MatTabChangeEvent) {
    if (tab.index === 5) {
      this.isShowSettlement = true;
      this.isShowCompletedSettlement = false;
    } else if (tab.index === 6) {
      this.isShowSettlement = false;
      this.isShowCompletedSettlement = true;
    } else {
      this.isShowSettlement = false;
      this.isShowCompletedSettlement = false;
    }
    if (tab.index === 2) {
      this.getRoomWiseRevenueBetweenDates();
    }
  }

  onChangeHostMobielViewOption(option: string) {
    if (option === 'RevenueDetails') {
      this.getRoomWiseRevenueBetweenDates();
    }
    if (option === 'LuckyBucks') {
      this.luckyBucks = true;
    } else {
      this.luckyBucks = false;
    }
  }

  getOwnerWebinarRoomsList() {
    this.isLoading.ownerRooms = true;
    // For owner portal, get all rooms instead of filtering by user
    this.webinarClient.getAllMAppedRoomsList().subscribe(res => {
      // Convert WebinarRoomDTO[] to WebinarRoomOwnerDTO[] format
      this.ownerRoomsList = res.map(room => {
        const ownerRoom = new WebinarRoomOwnerDTO();
        ownerRoom.webinarRoomId = room.roomId;
        ownerRoom.roomName = room.roomName;
        ownerRoom.userId = 0; // Not needed for owner portal
        ownerRoom.roomOwnerId = 0; // Not needed for owner portal
        ownerRoom.roomDescription = '';
        return ownerRoom;
      });
      this.isLoading.ownerRooms = false;
    }, error => {
      console.error(error);
      this.isLoading.ownerRooms = false;
    });
  }

  EditWebinar(webinarId: number) {
    // Owners can navigate to edit webinar if needed
    // For now, we'll just show a message or navigate to edit page
    // This can be customized based on requirements
    console.log('Edit webinar:', webinarId);
  }


  checkDecimalValue(number: number): any {
    const isDecimal = (number % 1 !== 0) ? true : false;
    if(isDecimal) {
      return number.toFixed(2);
    } else {
      return Math.floor(number);
    }
  } 

  onExportToExcel() {
    const purchaseHistory: PurchaseHistoryRevenueDTO[] = this.roomWiseRevenue.purchaseHistory;
    const dateFrom = moment(this.RevenueForm.controls.StartDate.value).format('yyy-MM-DD');
    const dateTo = moment(this.RevenueForm.controls.EndDate.value).format('yyy-MM-DD');
    const dates = dateFrom + ' To ' + dateTo;

    const modifiedHistories = [];
    purchaseHistory.map(x => {
      const modifiedObj = {
        'Webinar ID': x.webinarId.toString(),
        'Seat ID': x.seatId.toString(),
        'Transaction ID': x.transactionId.toString(),
        'Price Per Seat': x.price + '$',
        'User ID': x.userId.toString(),
        'Purchased Date': moment(x.createdDate).format('dd MMM yyyy h:mm:ss a'),
        'Order ID': x.orderId.toString(),
        'Payment ID': x.paymentId.toString(),
        'Currency': x.currency.toString(),
        'Order Date':moment(x.orderDate).format('dd MMM yyyy h:mm:ss a')
      }
      modifiedHistories.push(modifiedObj);
    });
     // for blank line
     const modifiedBlankObj = {
      'Webinar ID': '',
      'Seat ID': '',
      'Transaction ID': '',
      'Price Per Seat': '',
      'User ID': '',
      'Purchased Date': '',
      'Order ID': '',
      'Payment ID': '',
      'Currency': '',
      'Order Date': ''
    }
    modifiedHistories.push(modifiedBlankObj);

    // for total line display purpose
    const modifiedObj = {
      'Webinar ID': 'TOTAL AMOUNT',
      'Seat ID': '',
      'Transaction ID': '',
      'Price Per Seat': this.roomWiseRevenue.revenue + '$',
      'User ID': '',
      'Purchased Date': '',
      'Order ID': '',
      'Payment ID': '',
      'Currency': '',
      'Order Date': ''
    }
    modifiedHistories.push(modifiedObj);
    this.excelService.ExportToExcel(modifiedHistories, 'Revenue Details', dates, 25);
  }

  selectedRoomForValue(roomId: number) {
    return this.roomsList.find(x => x.roomId === Number(roomId)).roomName;
  }
}
